import React from 'react';
import { Link } from 'react-router-dom';
import BackButton from '../../components/BackButton';
import AppIcon from '../../components/AppIcon';

/**
 * صفحة "حسابي" للزائر (غير مسجل) — تسجيل دخول، إنشاء حساب، الإعدادات، الدعم (/support).
 * قسم الإعدادات متاح لأي شخص دون تسجيل دخول.
 */
const listItemClass =
  'w-full flex items-center gap-4 p-4 rounded-xl border border-slate-200 hover:bg-slate-50 hover:border-slate-300 transition-colors text-right';
const listIconClass =
  'w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0';
const listLabelClass = 'font-medium text-slate-800';

export default function AccountGuest() {
  return (
    <div className="min-h-screen bg-slate-50 p-4 md:p-6" dir="rtl">
      <div className="max-w-lg mx-auto pt-8">
        <div className="mb-6">
          <BackButton to="/" label="الرئيسية" />
        </div>
        <h1
          className="text-2xl font-bold text-slate-900 mb-2"
          style={{ fontFamily: 'IBM Plex Sans Arabic, sans-serif' }}
        >
          حسابي
        </h1>
        <p className="text-slate-600 mb-6">سجّل الدخول أو أنشئ حساباً للوصول إلى حجوزاتك والمفضلة والملف الشخصي.</p>

        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6 space-y-4">
          <Link to="/customer-login" className={listItemClass + ' block'}>
            <div className={listIconClass}>
              <AppIcon name="LogIn" size={20} className="text-primary" />
            </div>
            <span className={listLabelClass}>تسجيل دخول</span>
            <AppIcon name="ChevronLeft" size={18} className="text-slate-400 mr-auto" />
          </Link>

          <Link to="/customer-registration" className={listItemClass + ' block'}>
            <div className={listIconClass}>
              <AppIcon name="UserPlus" size={20} className="text-primary" />
            </div>
            <span className={listLabelClass}>إنشاء حساب</span>
            <AppIcon name="ChevronLeft" size={18} className="text-slate-400 mr-auto" />
          </Link>

          {/* قسم الإعدادات — صفحة مستقلة بداخلها إعدادات الموقع */}
          <Link to="/settings" className={listItemClass + ' block'}>
            <div className={listIconClass}>
              <AppIcon name="Settings" size={20} className="text-primary" />
            </div>
            <span className={listLabelClass}>الإعدادات</span>
            <AppIcon name="ChevronLeft" size={18} className="text-slate-400 mr-auto" />
          </Link>

          <Link to="/support" className={listItemClass + ' block'}>
            <div className={listIconClass}>
              <AppIcon name="Headphones" size={20} className="text-primary" />
            </div>
            <span className={listLabelClass}>الدعم والمساعدة</span>
            <AppIcon name="ChevronLeft" size={18} className="text-slate-400 mr-auto" />
          </Link>
        </div>
      </div>
    </div>
  );
}
